import { cva } from '@/styled-system/css';

export const progressStepperStepRecipe = cva({
  base: {
    '& > [data-c11n-component="ProgressStepper.StepInner"]': {
      display: 'grid',
      position: 'relative',
      cursor: 'default',
      zIndex: '2',
      margin: '0', // Safari
      background: 'none',
      border: 'none',
      padding: '0',
      width: '100%',
    },
    '& > a[data-c11n-component="ProgressStepper.StepInner"]': {
      textDecoration: {
        base: 'none',
        _hover: 'underline',
      },
    },
  },
  variants: {
    interactive: {
      true: {
        '& > a': {
          focusOutline: true,
        },
        '_hover': {
          '& > a[data-c11n-component="ProgressStepper.StepInner"]': {
            cursor: 'pointer',
          },
        },
      },
      false: {},
    },
    active: {
      true: {},
      false: {},
    },
    alignLabel: {
      center: {},
      left: {},
    },
    orientation: {
      horizontal: {
        'width': 'var(--c11n-step-width)',

        '& > [data-c11n-component="ProgressStepper.StepInner"]': {
          alignItems: 'center',
          gridTemplateRows: '{sizes.ProgressMeter.Node.default} auto',
          rowGap: 'ProgressMeter.gap.horizontal.node-toLabel',
        },
      },
      vertical: {
        'width': 'auto',
        'paddingBlockEnd': 'loose',

        '& > [data-c11n-component="ProgressStepper.StepInner"]': {
          gridTemplateColumns: '{sizes.ProgressMeter.Node.default} auto',
          columnGap: 'ProgressMeter.gap.vertical.node-toLabel',
        },
      },
    },
    variant: {
      complete: {},
      incomplete: {},
      critical: {},
      warning: {},
      notStarted: {},
      none: {},
      active: {},
    },
  },
  compoundVariants: [
    {
      orientation: 'vertical',
      alignLabel: ['left', 'center'],
      css: {
        '& > [data-c11n-component="ProgressStepper.StepInner"]': {
          alignItems: 'flex-start',
        },
      },
    },
    {
      orientation: 'horizontal',
      alignLabel: 'center',
      css: {
        '& > [data-c11n-component="ProgressStepper.StepInner"]': {
          justifyContent: 'center',
        },

        '& [data-c11n-component="ProgressStepper.Dot"]': {
          justifySelf: 'center',
        },
      },
    },
    {
      orientation: 'horizontal',
      alignLabel: 'left',
      css: {
        '&:nth-child(1)': {
          marginInlineStart:
            'calc((var(--c11n-step-width) / 2) - {sizes.ProgressMeter.Node.marker.notStarted})',
        },
        // The last step gets only half the width of the others. This prevents long label
        // text from awkwardly extending too far out. It also allows us to left-align the
        // labels without affecting the stepper width and progress bar positioning.
        '&:is(:last-child)': {
          width: 'calc(var(--c11n-step-width) / 2)',
        },
        '& > [data-c11n-component="ProgressStepper.StepInner"]': {
          justifyContent: 'flex-start',
        },
      },
    },
  ],
});
